import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export const fmtMoney = (n: number) => "€" + Math.round(n).toLocaleString("en-GB");
export const fmtNum = (n: number) => Math.round(n).toLocaleString("en-GB");
export const fmtPct = (n: number) => n.toFixed(1) + "%";

/** Compact money for macro figures: €85.8M, €420k, €1.2B. */
export function fmtCompactMoney(n: number): string {
  const a = Math.abs(n);
  if (a >= 1e9) return "€" + (n / 1e9).toFixed(1) + "B";
  if (a >= 1e6) return "€" + (n / 1e6).toFixed(1) + "M";
  if (a >= 1e3) return "€" + Math.round(n / 1e3) + "k";
  return "€" + Math.round(n);
}

/** A directional band, e.g. "€60M – €112M". Falls back to a single value when no band. */
export function fmtMoneyRange(low?: number | null, high?: number | null): string {
  if (low == null || high == null) return "—";
  return `${fmtCompactMoney(low)} – ${fmtCompactMoney(high)}`;
}
